var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { ThemeContext, } from "@/services/contextApi/themeContext";
import MPStorage from "@/services/LocalStorage";
import { customKeys } from "@/services/LocalStorage/LocalStorage";
var ThemeStoreProvider = function (_a) {
    var children = _a.children;
    var _b = __read(useState("light"), 2), theme = _b[0], setTheme = _b[1];
    var _c = __read(useState("light"), 2), modeLocal = _c[0], setModeLocal = _c[1];
    var _d = __read(useState(false), 2), componentMounted = _d[0], setComponentMounted = _d[1];
    var setMode = function (mode) {
        setModeLocal(mode);
        MPStorage.saveToLocalStorage(customKeys.THEME, mode);
        if (mode === "system") {
            setSystemTheme();
        }
        else {
            setTheme(mode);
        }
    };
    var mql = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)");
    var setSystemTheme = function () {
        if (mql.matches) {
            setTheme("dark");
        }
        else {
            setTheme("light");
        }
    };
    var handleDynamicSystemTheme = function () {
        var localTheme = MPStorage.getFromLocalStorage(customKeys.THEME);
        if (localTheme === "system") {
            setSystemTheme();
        }
    };
    useEffect(function () {
        try {
            mql.addEventListener("change", handleDynamicSystemTheme);
        }
        catch (error) {
            mql.addListener(handleDynamicSystemTheme);
        }
        return function () {
            try {
                mql.removeEventListener("change", handleDynamicSystemTheme);
            }
            catch (error) {
                mql.removeListener(handleDynamicSystemTheme);
            }
        };
    }, []);
    useEffect(function () {
        var localTheme = MPStorage.getFromLocalStorage(customKeys.THEME);
        if (localTheme) {
            setModeLocal(localTheme);
            if (localTheme === "system") {
                setSystemTheme();
            }
            else {
                setTheme(localTheme);
            }
        }
        else {
            setMode("light");
        }
        setComponentMounted(true);
    }, []);
    return (React.createElement(ThemeContext.Provider, { value: { theme: theme, setMode: setMode, componentMounted: componentMounted, mode: modeLocal } }, children));
};
export default ThemeStoreProvider;
//# sourceMappingURL=data:application/json;base64,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